import { render } from "./FilterManager.vue?vue&type=template&id=2517f3aa&ts=true"
import script from "./FilterManager.vue?vue&type=script&lang=ts"
export * from "./FilterManager.vue?vue&type=script&lang=ts"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__